import React, { useEffect, useState } from "react";
import { message, Tooltip } from "antd";
import medicineImg from "../../assets/Icons/medcine8.svg";
import cart from "../../assets/Icons/cart.svg";
import { APP_ROUTES } from "../../PageRouting/pageRoutes";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  handleLoginSignUpModal,
  LOGINMODAL,
} from "../../Redux/actions/commonActions";
import { FaMinus, FaPlus } from "react-icons/fa";
import {
  createCartOrderDtlItem,
  createCartOrderHdrItem,
  getCurrentTime,
} from "../../Shared/CartHelper";
import { AddtoCart, getCartDetails } from "../../Redux/actions/cartActions";
import PatientService from "../../Services/PatientService";

function MedicineCard({
  medicine,
  deliverable,
  address,
  patientMembershipDet,
}) {
  const [isMedicineThereInCart, setIsMedicineThereInCart] = useState(false);
  const [medCartData, setMedCartData] = useState(null);
  const [loader, setLoader] = useState(false);
  // const [patientMembershipDet, setPatientMembershipDet] = useState(null);
  const navigate = useNavigate();
  const { patientData } = useSelector((state) => state.auth);
  const { cartData } = useSelector((state) => state.cart);
  const { states, countries } = useSelector((state) => state.common);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (patientData && patientData?.patientId) {
  //     fetchMembershipDetails();
  //   }
  // }, [patientData]);

  // useEffect(() => {
  //     if (patientMembershipDet) {
  //         const currentPrice = medicine?.mrp || 0;
  //         const discountAmount = Math.floor(currentPrice * (patientMembershipDet?.discountPercentage / 100));
  //         const finalDoctorFee = currentPrice - discountAmount;
  //         setDiscountedPrice(finalDoctorFee);
  //     }
  // }, [medicine?.mrp, patientMembershipDet]);

  useEffect(() => {
    if (!cartData) {
      if (isMedicineThereInCart) setIsMedicineThereInCart(false);
      return;
    }
    setMedCartData(null);
    setIsMedicineThereInCart(false);
    const { cartOrderHdr } = cartData;
    const medData = cartOrderHdr?.find((item) => item.orderType === "DRUG");
    if (medData) {
      const medItems = medData?.cartOrderDtl;
      if (medItems && medItems?.length !== 0) {
        const isMedThereInCart = medItems?.find(
          (item) => item.orderCode === medicine.code,
        );
        if (isMedThereInCart) {
          setMedCartData(isMedThereInCart);
          setIsMedicineThereInCart(true);
        }
      }
    }
  }, [cartData, medicine]);

  const calculateDiscountedPrice = (medicine, patientMembershipDet) => {
    if (!patientMembershipDet) return medicine?.mrp;
    const membershipObj = patientMembershipDet.find(
      (m) => m.serviceCategory === medicine.drugCategory,
    );
    const currentPrice = medicine?.mrp || 0;
    const discountAmount = Math.floor(
      currentPrice * (membershipObj?.discountPercentage / 100),
    );
    const finalMedPrice = currentPrice - discountAmount;
    return finalMedPrice?.toFixed(2);
  };

  const handleMedDet = () => {
    if (!patientData && !patientData?.patientId) {
      dispatch(handleLoginSignUpModal({ data: true, actionType: LOGINMODAL }));
      return;
    }

    if (deliverable) {
      navigate(APP_ROUTES.MEDICINEDETAILS, { state: { medicine: medicine } });
    } else {
      message.error(
        "Pharmacy service is not available at your location. Please enter pincode / try another pincode.",
      );
    }
  };

  // const fetchMembershipDetails = async () => {
  //   const payload = {
  //     // patientId: patientData?.patientId,
  //     membershipCard: patientData?.membershipCard || "",
  //     serviceCategory: medicine?.drugCategory || "RX",
  //   };

  //   try {
  //     const response = await PatientService.patientMembershipDet(payload);
  //     // console.log(response.data);
  //     setPatientMembershipDet(response?.data?.data?.[0] || null);
  //   } catch (e) {
  //     console.error(e);
  //   }
  // };

  const handleIncreaseQty = async () => {
    if (!deliverable) {
      message.error(
        "Pharmacy service is not available at your location. Please enter pincode / try another pincode.",
      );
      return;
    }

    if (!medCartData || !cartData) return;

    const updatedCart = { ...cartData };
    const hdrIndex = updatedCart.cartOrderHdr.findIndex(
      (order) => order.orderType === "DRUG",
    );

    if (hdrIndex === -1) return;

    const cartMedObj = updatedCart.cartOrderHdr[hdrIndex];
    const dtlIndex = cartMedObj.cartOrderDtl.findIndex(
      (item) => item.orderCode === medCartData.orderCode,
    );

    if (dtlIndex === -1) return;

    setLoader(true);
    const item = cartMedObj.cartOrderDtl[dtlIndex];
    item.quantity += 1;
    item.amount = item.quantity * item.unitPrice;
    item.paidAmount = item.amount;
    item.orderState = "U";
    item.modifiedDate = getCurrentTime();

    // Recalculate header totals
    cartMedObj.amount = cartMedObj.cartOrderDtl.reduce(
      (sum, i) => sum + Number(i.amount),
      0,
    );
    cartMedObj.paidAmount = cartMedObj.cartOrderDtl.reduce(
      (sum, i) => sum + Number(i.paidAmount),
      0,
    );
    cartMedObj.modifiedDate = getCurrentTime();

    updatedCart.cartOrderHdr[hdrIndex] = cartMedObj;
    updatedCart.modifiedDate = getCurrentTime();

    let grandTotalAmount = updatedCart?.cartOrderHdr?.reduce((sum, order) => {
      return sum + (order?.paidAmount || 0);
    }, 0);

    const payload = {
      ...updatedCart,
      totalAmount: grandTotalAmount,
    };

    try {
      const updatedCartData = await dispatch(AddtoCart(payload));
      // dispatch(updateCartState(updatedCartData.data));
      const cartPayload = { patientId: patientData.patientId };
      dispatch(getCartDetails(cartPayload));
      setLoader(false);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
    // dispatch(getCartDetails({ patientId: patientData.patientId }));
  };

  const handleDecreaseQty = async () => {
    if (!deliverable) {
      message.error(
        "Pharmacy service is not available at your location. Please enter pincode / try another pincode.",
      );
      return;
    }

    if (!medCartData || !cartData) return;

    const updatedCart = { ...cartData };
    const hdrIndex = updatedCart.cartOrderHdr.findIndex(
      (order) => order.orderType === "DRUG",
    );

    if (hdrIndex === -1) return;

    const cartMedObj = updatedCart.cartOrderHdr[hdrIndex];
    const dtlIndex = cartMedObj.cartOrderDtl.findIndex(
      (item) => item.orderCode === medCartData.orderCode,
    );

    if (dtlIndex === -1) return;

    const item = cartMedObj.cartOrderDtl[dtlIndex];

    const now = getCurrentTime();
    setLoader(true);

    if (item.quantity > 1) {
      // Just decrease quantity
      item.quantity -= 1;
      item.amount = item.quantity * item.unitPrice;
      item.paidAmount = item.amount;
      item.orderState = "U";
      item.modifiedDate = now;
    } else {
      // Treat as a remove
      item.status = 0; // Soft delete
      item.orderState = "U";
      item.modifiedDate = now;
    }

    // Recalculate hdr totals based on active items
    const activeItems = cartMedObj.cartOrderDtl.filter((i) => i.status !== 0);
    cartMedObj.cartOrderDtl = cartMedObj.cartOrderDtl; // keep full list with soft deleted
    cartMedObj.amount = activeItems.reduce(
      (sum, i) => sum + Number(i.amount),
      0,
    );
    cartMedObj.paidAmount = activeItems.reduce(
      (sum, i) => sum + Number(i.paidAmount),
      0,
    );
    cartMedObj.modifiedDate = now;

    updatedCart.cartOrderHdr[hdrIndex] = cartMedObj;
    updatedCart.modifiedDate = now;

    let grandTotalAmount = updatedCart?.cartOrderHdr?.reduce((sum, order) => {
      return sum + (order?.paidAmount || 0);
    }, 0);

    const payload = {
      ...updatedCart,
      totalAmount: grandTotalAmount,
    };

    try {
      const updatedCartData = await dispatch(AddtoCart(payload));
      // dispatch(updateCartState(updatedCartData.data));
      const cartPayload = { patientId: patientData.patientId };
      dispatch(getCartDetails(cartPayload));
      setLoader(false);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };

  const handleAddToCart = async ({ itemObj, type }) => {
    if (!patientData && !patientData?.patientId) {
      dispatch(handleLoginSignUpModal({ data: true, actionType: LOGINMODAL }));
      return;
    }

    if (!deliverable) {
      message.error(
        "Pharmacy service is not available at your location. Please enter pincode / try another pincode.",
      );
      return;
    }

    if (!patientData) {
      message.error("Please select a patient");
      return;
    }

    if (!itemObj) return;
    if (!address) {
      message.error("Please select/add your delivery address.");
      return;
    }
    setLoader(true);
    const now = getCurrentTime();
    const existingCartId = cartData?.cartId;
    const cartHdrs = [...(cartData?.cartOrderHdr || [])];
    const itemCode = itemObj.code;
    const itemName = itemObj.medicineName;
    const itemCategory = itemObj.drugCategory;
    const vendorId = itemObj.pharmacyId;
    const price = parseFloat(itemObj.mrp || 0);

    const existingHdr = cartHdrs.find((hdr) => hdr.orderType === type);

    let payload;

    if (!existingCartId) {
      // No cart – create new
      const dtlItem = createCartOrderDtlItem({
        item: {
          code: itemCode,
          name: itemName,
          drugCategory: itemCategory,
          price,
          vendorId,
        },
        type,
        patientId: patientData?.patientId,
        user: patientData,
      });

      payload = {
        cartOrderHdr: [
          createCartOrderHdrItem({
            Acc_branch: {
              acc_Id: itemObj.pharmacyId,
              bran_Id: itemObj.branchId,
            },
            dtlItem,
            account: address,
            user: patientData,
            patientId: patientData.patientId,
            type,
          }),
        ],
        cartType: 1,
        patientId: patientData.patientId,
        paymentType: "",
        totalAmount: 0,
        status: 1,
      };

      let grandTotalAmount = payload?.cartOrderHdr?.reduce((sum, order) => {
        return sum + (order?.paidAmount || 0);
      }, 0);

      payload = {
        ...payload,
        totalAmount: grandTotalAmount,
      };
    } else {
      // Update existing cart
      const newHdrs = cartHdrs.map((hdr) => {
        if (hdr.orderType !== type) return hdr;

        const existingItem = hdr.cartOrderDtl.find(
          (i) => i.orderCode === itemCode,
        );
        let updatedDtl = [...hdr.cartOrderDtl];
        if (existingItem) {
          updatedDtl = updatedDtl.map((i) =>
            i.orderCode === itemCode
              ? {
                  ...i,
                  quantity: i.quantity + 1,
                  amount: (i.quantity + 1) * i.unitPrice,
                  paidAmount: (i.quantity + 1) * i.unitPrice,
                  modifiedDate: now,
                  orderState: "U",
                }
              : i,
          );
        } else {
          const newDtlItem = createCartOrderDtlItem({
            item: {
              code: itemCode,
              name: itemName,
              drugCategory: itemCategory,
              price,
              vendorId,
            },
            type,
            patientId: patientData.patientId,
            user: patientData,
            cartId: existingCartId,
          });
          updatedDtl.push(newDtlItem);
        }

        const totalAmt = updatedDtl.reduce(
          (sum, i) => sum + Number(i.amount),
          0,
        );
        const totalPaid = updatedDtl.reduce(
          (sum, i) => sum + Number(i.paidAmount),
          0,
        );
        return {
          ...hdr,
          cartOrderDtl: updatedDtl,
          amount: parseFloat(totalAmt),
          paidAmount: parseFloat(totalPaid),
          modifiedDate: now,
        };
      });

      // If this type doesn't exist yet, add it
      if (!existingHdr) {
        const dtlItem = createCartOrderDtlItem({
          item: {
            code: itemCode,
            name: itemName,
            drugCategory: itemCategory,
            price,
            vendorId,
          },
          type,
          patientId: patientData.patientId,
          user: patientData,
          cartId: existingCartId,
        });

        newHdrs.push(
          createCartOrderHdrItem({
            Acc_branch: {
              acc_Id: itemObj.pharmacyId,
              bran_Id: itemObj.branchId,
            },
            dtlItem,
            account: address,
            user: patientData,
            patientId: patientData.patientId,
            type,
          }),
        );
      }

      let grandTotalAmount = newHdrs?.reduce((sum, order) => {
        return sum + (order?.paidAmount || 0);
      }, 0);

      payload = {
        ...cartData,
        cartId: existingCartId,
        cartOrderHdr: newHdrs,
        modifiedDate: now,
        totalAmount: grandTotalAmount,
      };
    }

    try {
      const updatedCart = await dispatch(AddtoCart(payload));
      // dispatch(updateCartState(updatedCart.data));
      const cartPayload = { patientId: patientData.patientId };
      dispatch(getCartDetails(cartPayload));
      setLoader(false);
      message.success("Medicine added to cart successfully.");
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };
  return (
    <div>
      <article
        key={medicine.id}
        className="overflow-hidden relative min-h-[18rem] pt-2 bg-white rounded-md border border-solid border-slate-200 max-w-[238px] shadow-[0px_4px_72px_rgba(0,0,0,0.04)] text-zinc-800"
        onClick={handleMedDet}
      >
        <div className="px-3 w-full text-xs">
          <img
            src={medicineImg}
            alt="Product"
            className="object-contain w-full rounded-md aspect-[1.75] shadow-[0px_4px_72px_rgba(0,0,0,0.04)]"
          />
          <div className="flex flex-col mt-2 max-w-full">
            <Tooltip title={medicine.medicineName}>
              <h3 className="text-sm font-semibold text-zinc-800">
                {medicine.medicineName && medicine.medicineName.length > 10
                  ? `${medicine.medicineName.slice(0, 10)}...`
                  : medicine.medicineName}
              </h3>
            </Tooltip>
            <p className="gap-1.5 self-start mt-2 text-slate-500">
              {medicine.packaging}
            </p>
            <p className="mt-2 w-full text-zinc-800">
              {medicine.saltComposition && medicine.saltComposition.length > 50
                ? `${medicine.saltComposition.slice(0, 50)}...`
                : medicine.saltComposition}
            </p>
          </div>
        </div>
        <div className="absolute bottom-0 flex overflow-hidden gap-5 justify-between px-3 py-2.5 mt-3.5 w-full text-base font-semibold whitespace-nowrap bg-cyan-50 rounded-none border border-solid border-slate-300">
          <div
            onClick={(e) => e.stopPropagation()}
            className="flex justify-between items-center w-full"
          >
            {patientMembershipDet ? (
              <div className="flex items-center gap-2 my-2">
                <div className="flex items-center gap-1">
                  <span className="text-lg font-sans font-semibold text-[#333333]">
                    <span className="text-sm font-normal text-gray-400 mr-0.5">
                      INR
                    </span>
                    {calculateDiscountedPrice(medicine, patientMembershipDet)}
                  </span>
                  <span className="line-through text-[#738483] font-opensans text-base">
                    {medicine.mrp}
                  </span>
                </div>
              </div>
            ) : (
              <p className="my-auto text-zinc-800">
                <span className="text-sm font-normal text-gray-400 mr-0.5">
                  INR
                </span>
                {medicine.mrp}
              </p>
            )}
            {!isMedicineThereInCart ? (
              <button
                onClick={() =>
                  handleAddToCart({
                    itemObj: medicine,
                    type: "DRUG",
                  })
                }
                disabled={loader}
                aria-label="Add to cart"
              >
                <img
                  src={cart}
                  alt="Add to cart"
                  className="object-contain shrink-0 w-8 aspect-square rounded-[50px]"
                />
              </button>
            ) : (
              <div className="flex justify-end items-center w-full">
                <button
                  className="bg-[#189FAA] w-5 h-5 p-0.5 flex items-center justify-center font-sans font-semibold text-white rounded-full text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={handleDecreaseQty}
                  disabled={loader}
                >
                  <FaMinus className="w-3 h-3" />
                </button>

                <input
                  className="mx-2 border rounded-full text-center w-6 h-6 p-0.5 text-xs"
                  type="text"
                  value={medCartData?.quantity || 0}
                  readOnly
                />

                <button
                  className="bg-[#189FAA] w-5 h-5 p-0.5 flex items-center justify-center font-sans font-semibold text-white rounded-full text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={handleIncreaseQty}
                  disabled={loader}
                >
                  <FaPlus className="w-3 h-3" />
                </button>
              </div>
            )}
          </div>
        </div>
      </article>
    </div>
  );
}

export default MedicineCard;
